<template>
  <div class="login_con">
    <p class="title">扫码登录</p>
    <div class="close_btn" @click="$emit('close')"></div>
    <div class="qrcode_con">
      <qrcode
        v-if="sessionId"
        className="scan_qrcode_login"
        :text="qrcodeContent"
        :width="150"
        :height="150"
        :icon="qrcodeIcon"
      />
      <div class="other_status_con" v-if="loading">
        <img class="icon loading" src="./image/relaod_icon.png" alt="" />
      </div>
      <div class="other_status_con" v-else-if="status === 2">
        <img class="icon" @click="getSession" src="./image/relaod_icon.png" alt="" />
      </div>
      <div class="other_status_con" v-else-if="status === 1">
        <img class="icon" src="./image/scan_success_icon.png" alt="" />
      </div>
    </div>
    <div class="tips">
      <p class="text_1" v-if="tips[0]">{{ tips[0] }}</p>
      <p class="text_2" v-if="tips[1]">{{ tips[1] }}</p>
    </div>
    <div class="tips_con">
      <img
        :class="{
          checkbox: true,
          disabled: status !== 0,
        }"
        @click="toggleCacheLogin"
        :src="cacheLogin ? checkBoxIcons.active : checkBoxIcons.normal"
        alt=""
      />
      <span>7天免登录</span>
    </div>
    <div class="toggle_tips">
      切换至 <span class="green" @click="$emit('toggleByPhone')">账户登录</span>
    </div>
  </div>
</template>
<script>
import qrcodeIcon from './image/qrcode_icon.png'
import checkbox_active from './image/checkbox_active.png'
import checkbox from './image/checkbox.png'

export default {
  props: ['createSession', 'checkSessionStatus'],
  data() {
    return {
      checkBoxIcons: {
        normal: checkbox,
        active: checkbox_active,
      },
      qrcodeIcon,
      sessionId: '',
      cacheLogin: true,
      loading: true,
      // 0：初始化 1：已扫码 2：二维码失效 3：取消授权 4：授权成功 5:授权失败
      status: 0,
      timer: null,
    }
  },
  computed: {
    tips() {
      if (this.status === 0) {
        return ['请用无尽冬日手游扫码登录', '前往【设置】-【扫一扫】完成扫码']
      }
      if (this.status === 1) {
        return ['扫码成功！请在手机确认']
      }
      if (this.status === 2) {
        return ['二维码已失效', '请点击刷新重新获取二维码']
      }
      return []
    },
    qrcodeContent() {
      if (!this.sessionId) return
      return window.btoa(
        JSON.stringify({
          session: this.sessionId,
          action: 'webshop_cn_login',
        })
      )
    },
  },
  created() {
    this.getSession()
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  methods: {
    // 获取session
    async getSession() {
      this.status = 0
      this.loading = true
      const res = await this.createSession('qrcode')
      this.sessionId = res.session_id
      this.loopSessionStatus()
      this.loading = false
    },
    // 轮询更新session状态
    async loopSessionStatus() {
      const res = await this.checkSessionStatus(this.sessionId)

      this.status = res.status

      // 未扫码，以及已扫码，继续轮询状态
      if (this.status === 0 || this.status === 1) {
        this.timer = setTimeout(this.loopSessionStatus, 1000)
      }

      // 取消授权或者授权失败后自动刷新二维码
      if (this.status === 3 || this.status === 5) {
        this.getSession()
      }

      // 授权成功,通知父组件同步登录态
      if (this.status === 4) {
        this.$emit('success', {
          sessionId: this.sessionId,
          cacheLogin: this.cacheLogin,
        })
        this.$emit('close')
      }
    },
    toggleCacheLogin() {
      if (this.status === 0) {
        this.cacheLogin = !this.cacheLogin
      }
    },
  },
}
</script>
<style>
.scan_qrcode_login {
  width: 150px;
  height: 150px;
}
@media (max-width: 1024px) {
  .scan_qrcode_login {
    width: 3rem;
    height: 3rem;
  }
}
</style>
<style scoped lang="less">
.login_con {
  position: relative;
  width: 490px;
  background: #fff;
  border-radius: 16px;
  padding: 31px 0 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .title {
    margin-bottom: 12px;
    font-size: 27px;
    color: #202226;
    text-align: center;
  }
  .close_btn {
    position: absolute;
    width: 35px;
    height: 35px;
    top: 16px;
    right: 16px;
    cursor: pointer;
    transform: scale(0.8);
    &::before,
    &::after {
      position: absolute;
      content: '';
      display: block;
      height: 5px;
      width: 42px;
      background: #808080;
      border-radius: 5px;
    }
    &::before {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(45deg);
    }
    &::after {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }
  .qrcode_con {
    position: relative;
    margin-bottom: 12px;
    width: 150px;
    height: 150px;
    .other_status_con {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(255, 255, 255, 0.8);
      .icon {
        width: 58px;
        height: 58px;
        cursor: pointer;
        &.loading {
          animation: rotate 2s linear infinite;
          @keyframes rotate {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }
        }
      }
    }
  }
  .tips {
    width: 300px;
    padding: 12px 30px;
    background: #f4f4f4;
    border-radius: 10px;
    border: 2px solid #eae9e9;
    font-size: 16px;
    color: #3c3d40;
    line-height: 26px;
    text-align: center;
    margin-bottom: 16px;
    .text_1 {
      font-size: 20px;
      color: #000000;
      line-height: 20px;
    }
    .text_2 {
      margin-top: 10px;
      font-size: 16px;
      color: #3c3d40;
      line-height: 16px;
    }
  }
  .tips_con {
    position: relative;
    display: flex;
    align-items: center;
    font-size: 15px;
    color: #787878;
    white-space: nowrap;
    margin-bottom: 36px;
    .checkbox {
      width: 28px;
      height: 28px;
      margin-right: 2px;
      cursor: pointer;
      &.disabled {
        cursor: not-allowed;
      }
    }
    a {
      color: #07c261;
      text-decoration: none;
    }
    .error_msg {
      left: 30px;
    }
  }
  .toggle_tips {
    font-size: 18px;
    color: #3c3d40;
    line-height: 31px;
    .green {
      color: #04a93e;
      cursor: pointer;
      margin-left: 20px;
    }
  }
}

@media (max-width: 1024px) {
  .login_con {
    width: 6rem;
    border-radius: 0.16rem;
    padding: 0.42rem 0;
    .title {
      margin-bottom: 0.2rem;
      font-size: 0.38rem;
    }
    .close_btn {
      width: 0.35rem;
      height: 0.35rem;
      top: 0.16rem;
      right: 0.16rem;
      transform: scale(0.8);
      &::before,
      &::after {
        height: 0.05rem;
        width: 0.42rem;
        border-radius: 0.05rem;
      }
    }
    .qrcode_con {
      margin-bottom: 0.12rem;
      width: 3rem;
      height: 3rem;
      .other_status_con {
        .icon {
          width: 1.2rem;
          height: 1.2rem;
          cursor: pointer;
        }
      }
    }
    .tips {
      width: 4rem;
      padding: 0.14rem 0.3rem;
      border-radius: 10px;
      border: 1px solid #eae9e9;
      font-size: 0.22rem;
      line-height: 0.3rem;
      margin-bottom: 0.22rem;
      .text_1 {
        font-size: 0.28rem;
        color: #000000;
        line-height: 0.3rem;
      }
      .text_2 {
        margin-top: 0.16rem;
        font-size: 0.22rem;
        color: #3c3d40;
        line-height: 0.3rem;
      }
    }
    .tips_con {
      font-size: 0.22rem;
      margin-bottom: 0.24rem;
      .checkbox {
        width: 0.35rem;
        height: 0.35rem;
      }
      .error_msg {
        left: 0.42rem;
      }
    }
    .toggle_tips {
      font-size: 0.24rem;
      line-height: 0.3rem;
      .green {
        margin-left: 0.2rem;
      }
    }
  }
}
</style>
